function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpCircle = function SvgHelpCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.089 13C13.3241 12.3317 13.7882 11.7681 14.399 11.4091C15.0098 11.0502 15.7279 10.9189 16.4262 11.0387C17.1245 11.1585 17.7578 11.5215 18.2141 12.0635C18.6703 12.6055 18.9201 13.2915 18.919 14C18.919 16 15.919 17 15.919 17M16 21H16.01M16 26C21.522 26 26 21.523 26 16C26 10.477 21.522 6 16 6C10.478 6 6 10.477 6 16C6 21.523 10.477 26 16 26Z",
    stroke: props.fill,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgHelpCircle;